import React from 'react';
import PropTypes from 'prop-types';
import { Form, Input } from 'semantic-ui-react';
import InputNumberFormat from 'components/common/InputNumberFormat';

const CreditUserForm = ({ form, onChange }) => {
  const handleChange = (e, { name, value }) => {
    onChange(name, value);
  };

  return (
    <div>
      <InputNumberFormat
        required
        name="amount"
        control={Input}
        label="Amount"
        type="number"
        placeholder="Amount..."
        onChange={handleChange}
        value={form.amount || ''}
      />
      <Form.TextArea
        required
        label="Description"
        placeholder="Type something..."
        name="description"
        className="textarea"
        onChange={handleChange}
        value={form.description || ''}
      />
    </div>
  );
};

CreditUserForm.propTypes = {
  form: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default CreditUserForm;
